import assets from '@/network/assets'
import * as Network from '@/helpers/network.js'
import { getFileType } from '@/helpers/utils.js'
export function uploadSingleFile(file, size, highQuality, url) {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('size', size)
    formData.append('highQuality', highQuality)
    return assets.post(Network.provideURL(url), formData)
}

function uploadSequential(payloads, currentIndex, results, resolve, reject) {
    let currentPayload = payloads[currentIndex]
    uploadSingleFile(
        currentPayload.data,
        currentPayload.size,
        currentPayload.highQuality,
        currentPayload.url
    )
        .then(response => {
            results.push(response.data)
            if (currentIndex == payloads.length - 1) {
                resolve(results)
            } else {
                currentIndex++
                uploadSequential(
                    payloads,
                    currentIndex,
                    results,
                    resolve,
                    reject
                )
            }
        })
        .catch(error => {
            reject(error)
        })
}

export function uploadMultiple(payloads) {
    return new Promise((resolve, reject) => {
        if (payloads.length == 0) {
            resolve([])
        } else if (payloads.length > 1) {
            let results = []
            uploadSequential(payloads, 0, results, resolve, reject)
        } else if (payloads.length == 1) {
            uploadSingleFile(
                payloads[0].data,
                payloads[0].size,
                payloads[0].highQuality,
                payloads[0].url
            )
                .then(response => {
                    resolve([response.data])
                })
                .catch(error => {
                    reject(error)
                })
        }
    })
}
export function uploadAttachments(e, dropped, directory, progressFunction) {
    const files = dropped ? [...e.dataTransfer.files] : [...e.target.files]
    const dir = directory ? directory : ''
    const url = `assets/${dir}`
    const promises = files.map(file => {
        return new Promise((resolve, reject) => {
            getFileCanvas(file)
                .then(formData => {
                    let config = {}
                    if (progressFunction) {
                        config.onUploadProgress = event =>
                            progressFunction(
                                Math.round((event.loaded * 100) / event.total)
                            )
                    }
                    assets
                        .post(url, formData, config)
                        .then(({ data }) => {
                            resolve(data)
                        })
                        .catch(error => {
                            reject(error)
                        })
                })
                .catch(error => {
                    reject(error)
                })
        })
    })
    return Promise.all(promises)
}
export function getFileCanvas(file) {
    return new Promise(resolve => {
        const getOrientedImage = require('exif-orientation-image')
        getOrientedImage(file, (err, canvas) => {
            const formData = new FormData()
            if (!err) {
                canvas.toBlob(blob => {
                    formData.append('file', blob, file.name)
                    resolve(formData)
                })
            } else {
                formData.append('file', file, file.name)
                resolve(formData)
            }
        })
    })
}
export function getAssetFromFile(e, dropped) {
    const files = dropped ? [...e.dataTransfer.files] : [...e.target.files]
    const promises = files.map((file, index) => {
        return new Promise(resolve => {
            const getOrientedImage = require('exif-orientation-image')
            getOrientedImage(file, (err, canvas) => {
                if (!err) {
                    canvas.toBlob(blob => {
                        const assetObject = getAssetObject(blob, file, index)
                        resolve(assetObject)
                    })
                } else {
                    const assetObject = getAssetObject(file, file, index)
                    resolve(assetObject)
                }
            })
        })
    })
    return Promise.all(promises)
}
function getAssetObject(data, file, index) {
    return {
        data: data,
        path: window.URL.createObjectURL(data),
        name: file.name,
        type: getFileType(file.name),
        local: true,
        index: index
    }
}
export function uploadLocalAssets(files, directory, progressFunction) {
    const dir = directory ? directory : ''
    const url = `assets/${dir}`
    const promises = files.map(file => {
        let config = {}
        if (progressFunction) {
            config.onUploadProgress = event =>
                progressFunction(Math.round((event.loaded * 100) / event.total))
        }
        const formData = new FormData()
        formData.append('file', file.data, file.name)
        return assets.post(url, formData, config).then(({ data }) => {
            return data
        })
    })
    return Promise.all(promises)
}
